import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";

const values = [
  {
    icon: "ri-sparkling-2-line",
    title: "分类清晰",
    desc: "萌系、甜宠、恋爱三大分类一目了然，配合标签与搜索，快速找到你心仪的少女漫。",
  },
  {
    icon: "ri-refresh-line",
    title: "每日更新",
    desc: "坚持每天上新，热门连载定时更新，让你永远有新鲜的甜宠剧情可追。",
  },
  {
    icon: "ri-user-heart-line",
    title: "尊重创作",
    desc: "我们珍视每一位作者与每一部作品，努力营造尊重、友好的追漫社区氛围。",
  },
  {
    icon: "ri-hand-heart-line",
    title: "轻松畅读",
    desc: "无需下载、无需注册登录，点开即看，把快乐的门槛降到最低。",
  },
];

const testimonials = [
  {
    name: "软糖少女",
    role: "萌系漫画爱好者",
    quote: "在可可漫画网追《捡到一只小奶团》追到停不下来，画风又软又治愈，更新也超准时！",
  },
  {
    name: "奶昔同学",
    role: "甜宠漫画重度读者",
    quote: "甜宠分类简直是我的快乐源泉，每天睡前刷几话，一整天的疲惫都被甜化了。",
  },
  {
    name: "星野绘",
    role: "恋爱漫画同好",
    quote: "分类很清楚，找《星星打翻的夜晚》一下就找到了，页面也干净，看得很舒服。",
  },
];

export default function AboutPage() {
  return (
    <div className="bg-background-50">
      <Navbar />
      <main className="pt-16">
        <section className="relative overflow-hidden bg-gradient-to-b from-primary-100 via-background-50 to-background-50 py-16 text-center md:py-20">
          <div className="mx-auto max-w-3xl px-4 md:px-6">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-sm text-primary-700">
              <i className="ri-ghost-smile-line" />
              关于我们
            </span>
            <h1 className="mt-5 font-heading text-4xl text-foreground-900 md:text-5xl">把心动与甜蜜，都装进漫画里</h1>
            <p className="mt-5 text-base leading-relaxed text-foreground-600">
              可可漫画网是一个专注萌系少女与甜宠题材的在线漫画阅读平台。我们收录可爱画风、软萌角色的恋爱漫画，用清晰分类与每日更新，陪你度过每一个想被治愈的瞬间。
            </p>
          </div>
        </section>

        <section className="py-14 md:py-16">
          <div className="mx-auto max-w-7xl px-4 md:px-6">
            <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:items-center">
              <div>
                <span className="text-sm font-medium tracking-wide text-primary-500">我们的故事</span>
                <h2 className="mt-3 font-heading text-3xl text-foreground-900">为热爱少女漫的你而生</h2>
                <p className="mt-5 text-base leading-relaxed text-foreground-600">
                  在这个快节奏的生活里，我们相信总需要一点甜。可可漫画网应运而生，希望把那些画风软萌、剧情甜蜜的漫画集中呈现，让每一个热爱恋爱与萌系题材的你，都能在几话之间收获片刻治愈与快乐。
                </p>
                <p className="mt-4 text-base leading-relaxed text-foreground-600">
                  无论你是萌系角色控、甜宠剧情党，还是恋爱情节的忠实读者，都能在这里找到属于自己的那一部作品。分类清晰、更新稳定、阅读顺畅，是我们一直坚持的小小心意。
                </p>
                <div className="mt-6 flex items-center gap-6">
                  <div>
                    <p className="font-heading text-2xl text-primary-600">300+</p>
                    <p className="mt-1 text-sm text-foreground-500">精选连载</p>
                  </div>
                  <div>
                    <p className="font-heading text-2xl text-primary-600">10w+</p>
                    <p className="mt-1 text-sm text-foreground-500">追漫读者</p>
                  </div>
                  <div>
                    <p className="font-heading text-2xl text-primary-600">每日</p>
                    <p className="mt-1 text-sm text-foreground-500">稳定上新</p>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-5">
                {values.map((v) => (
                  <div key={v.title} className="rounded-2xl bg-background-100 p-6">
                    <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                      <i className={`${v.icon} text-2xl`} />
                    </span>
                    <h3 className="mt-4 text-lg font-medium text-foreground-900">{v.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-500">{v.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-16">
          <div className="mx-auto max-w-7xl px-4 md:px-6">
            <div className="mb-10 text-center">
              <span className="text-sm font-medium tracking-wide text-primary-500">读者口碑</span>
              <h2 className="mt-3 font-heading text-3xl text-foreground-900">他们都在这里快乐追漫</h2>
            </div>
            <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
              {testimonials.map((t) => (
                <figure key={t.name} className="flex flex-col rounded-2xl bg-background-50 p-6">
                  <i className="ri-double-quotes-l text-3xl text-primary-300" />
                  <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                    {t.quote}
                  </blockquote>
                  <figcaption className="mt-5 flex items-center gap-3">
                    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-100 text-accent-600">
                      <i className="ri-user-smile-line text-xl" />
                    </span>
                    <div>
                      <p className="font-medium text-foreground-900">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16">
          <div className="mx-auto max-w-7xl px-4 md:px-6">
            <div className="grid grid-cols-1 gap-8 rounded-3xl bg-primary-500 p-8 md:grid-cols-2 md:p-12">
              <div>
                <h2 className="font-heading text-3xl text-background-50">联系我们</h2>
                <p className="mt-3 max-w-md text-sm leading-relaxed text-background-50/85">
                  对漫画推荐、内容收录或网站功能有任何建议，欢迎通过以下方式联系我们。我们很乐意倾听每一位读者的声音。
                </p>
                <div className="mt-6 space-y-3 text-sm text-background-50/90">
                  <p className="flex items-center gap-2">
                    <i className="ri-mail-line text-lg" />
                    hello@keke-manga.example
                  </p>
                  <p className="flex items-center gap-2">
                    <i className="ri-wechat-line text-lg" />
                    可可漫画网官方公众号
                  </p>
                  <p className="flex items-center gap-2">
                    <i className="ri-time-line text-lg" />
                    工作日 09:00 - 18:00
                  </p>
                </div>
              </div>
              <div className="flex flex-col items-start justify-center gap-4">
                <div className="rounded-2xl bg-background-50 p-6">
                  <h3 className="font-medium text-foreground-900">有想看的漫画推荐？</h3>
                  <p className="mt-2 text-sm text-foreground-500">
                    欢迎告诉我们你希望收录的作品或题材，我们会认真评估并努力丰富内容库。
                  </p>
                  <Link
                    to="/category/all"
                    className="mt-4 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
                  >
                    去逛逛全部漫画
                    <i className="ri-arrow-right-line" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <BackToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Organization",
                name: "可可漫画网",
                url: "https://adorabook.github.io/",
                logo: "https://adorabook.github.io/vite.svg",
                description: "专注萌系少女与甜宠题材的在线漫画阅读平台",
                email: "hello@keke-manga.example",
              },
              {
                "@type": "AboutPage",
                name: "关于我们 - 可可漫画网",
                url: "https://adorabook.github.io/about",
                description: "可可漫画网是一个专注萌系少女与甜宠题材的在线漫画阅读平台，收录可爱画风、软萌角色的恋爱漫画，每日更新，分类清晰。",
                breadcrumb: {
                  "@type": "BreadcrumbList",
                  itemListElement: [
                    { "@type": "ListItem", position: 1, name: "首页", item: "https://adorabook.github.io/" },
                    { "@type": "ListItem", position: 2, name: "关于我们" },
                  ],
                },
              },
            ],
          }),
        }}
      />
    </div>
  );
}